import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { dateFormat, dayFormat, getColor } from "../tools";

const getDefaultStart = (date) => {
  let now = moment(date);
  // Getting hour and minute
  const hour = now.hour();
  const minute = now.minute();
  // Rounding minute on 30 mins interval
  if (minute <= 30) {
    now.set({ minutes: 30 });
  } else if (minute > 30 && hour < 23) {
    now.set({ hour: hour + 1, minute: 0 });
  } else {
    now.set({ hour: 0, minute: 0 });
  }
  return moment(now).format(dateFormat);
};

export const initInteraction = {
  id: null,
  name: "(No survey)",
};

export default function getEvent({ type, payload }) {
  const interaction = payload?.interaction ?? initInteraction;
  const basicEvent = {
    id: uuidv4(),
    title: interaction.name,
    itemId: interaction.id,
    backgroundColor: getColor(`${interaction.id}`),
    reminderIntervals: [],
  };
  const event = payload?.event ?? {};
  switch (type) {
    default:
    case "INITIAL_EVENT":
      return {
        ...basicEvent,
        start: getDefaultStart(new Date()),
        end: null,
        id: "-1",
      };

    case "SERVER_EVENT":
      //console.log("IMPORT SERVER EVENT");
      const serverDateFormat = "YYYY-MM-DD HH:mm:ss";
      let startTime = moment.utc(event.startTime, serverDateFormat).valueOf();
      //console.log(event.startTime);
      //console.log(startTime);
      let endTime = moment.utc(event.endTime, serverDateFormat).valueOf();

      // Templates/Protocols
      const lastMidnight = moment
        .utc(payload?.startDay ?? moment().format(dayFormat), dayFormat)
        .startOf("date")
        .valueOf();

      if (payload?.delay) {
        startTime = moment.utc(startTime)
          .add(payload.delay, "seconds")
          .valueOf();
      }

      // This day, relative to the starting date
      if (event.scheduleType === 1) {
        // relative
        startTime = lastMidnight + startTime;
        endTime = lastMidnight + endTime;
      }

      // The next day of this type (1st Monday, 3rd Tuesday, ...), relative to the starting date
      if (event.scheduleType === 2) {
        //calculate nth X day
        const n = Math.floor(startTime / (7 * 24 * 3600 * 1000)); // # weeks
        const X = Math.floor(
          (startTime % (7 * 24 * 3600 * 1000)) / (24 * 3600 * 1000)
        ); // # day number 0 = Sunday, 6 = Saturday
        const Y = (startTime % (7 * 24 * 3600 * 1000)) % (24 * 3600 * 1000); // aantal ms

        const lastMidnightDay =
          moment
            .utc(payload?.startDay ?? moment().format(dayFormat), dayFormat)
            .startOf("date")
            .isoWeekday() % 7;
        const dayShift = (X - lastMidnightDay + 7) % 7;

        const timeDifference = endTime - startTime;
        startTime = lastMidnight + (n * 7 + dayShift) * 24 * 3600 * 1000 + Y;
        endTime = startTime + timeDifference;
      }

      return {
        ...basicEvent,
        ...event,
        id: `${payload.event.beepId}`,
        type: "SERVER_EVENT",
        start: moment.utc(startTime).format(dateFormat),
        end: payload.event.randomizationScheme
          ? moment.utc(endTime).format(dateFormat)
          : null,
      };

    case "NEW_MONTH_EVENT":
      // copy timestamp to a new date
      const defaultStart = getDefaultStart(
        moment(payload.startDay, dateFormat).set({
          hour: moment().hour(),
          minute: moment().minute(),
        })
      );
      return {
        ...basicEvent,
        start: defaultStart,
        end: null,
        //endDay: defaultStart,
      };

    // payload: { startDay: date, interaction: survey }
    case "NEW_WEEK_EVENT":
      return {
        ...basicEvent,
        start: moment(payload.startDay).format(dateFormat),
        end: null,
      };

    case "DUPLICATE_EVENT":
      return {
        ...event,
        id: uuidv4(),
        start: payload.start,
        end: payload.end,
        /* title: payload.event.title,
        itemId: payload.event.itemId,
        backgroundColor: payload.event.backgroundColor, */
      };
  }
}
